export default __webpack_public_path__ + "static/media/single-staggered-border-left.919a7695.svg";